<template>
  <div>
    <!-- test -->
    <!-- 搜索 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="用户账号:">
          <el-input v-model="searchValue.username"></el-input>
        </el-form-item>
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-input v-model="searchValue.zone_name"></el-input>
        </el-form-item>
        <el-form-item label="角色名:">
          <el-input v-model="searchValue.name"></el-input>
        </el-form-item>
        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker> </el-form-item
        ><br />
        <el-form-item label="订单号:">
          <el-input v-model="searchValue.order_no"></el-input>
        </el-form-item>
        <el-form-item label="CP订单号:">
          <el-input v-model="searchValue.cp_order_no"></el-input>
        </el-form-item>
        <el-form-item label="支付单号:">
          <el-input v-model="searchValue.pay_order_no"></el-input>
        </el-form-item>

        <el-form-item label="订单状态:">
          <el-select
            v-model="searchValue.status"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="(value, key) in ordersList"
              :key="key"
              :label="value"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelSelectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.group_channel_ids"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道包ID:">
          <el-input v-model="searchValue.game_channel_package_id"></el-input>
        </el-form-item>
        <el-form-item>
        <el-form-item label="支付类型:">
          <el-select
            v-model="searchValue.pay_type"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in payTypeList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
          <el-button type="primary" @click="searchOrderList">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportOrder()">导出</el-button>
        </el-form-item>
      </el-form>
      <el-button type="warning" plain @click="supplementOrderDialog"
        >补单</el-button
      >
    </div>
    <!-- 订单统计 -->
    <ul class="order-statistics">
      <li>
        <span>充值笔数：</span>
        <em>{{ orderData.count }}</em>
      </li>
      <li>
        <span>支付成功率：</span>
        <em>{{ orderData.payRate }}%</em>
      </li>
      <li>
        <span>总订单金额：</span>
        <em>{{ orderData.sumMoeny }}</em>
      </li>
      <li>
        <span>总到账金额：</span>
        <em>{{ orderData.payMoney }}</em>
      </li>
      <li>
        <span>平均到账金额：</span>
        <em>{{ orderData.avgMoney }}</em>
      </li>
    </ul>
    <!-- 订单列表 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column fixed prop="id" label="订单ID" width="80">
      </el-table-column>
      <el-table-column prop="user.username" label="账号"> </el-table-column>
      <el-table-column prop="game.name" label="游戏"> </el-table-column>
      <el-table-column prop="zone_name" label="区服"> </el-table-column>
      <el-table-column prop="name" label="角色名"> </el-table-column>
      <el-table-column prop="role_id" label="角色id"> </el-table-column>
      <el-table-column prop="channels.name" label="渠道"> </el-table-column>
      <el-table-column prop="game_channel_package_id" label="渠道包ID">
      </el-table-column>
      <el-table-column prop="subject" label="商品"> </el-table-column>
      <el-table-column prop="pay_type" label="支付类型"> </el-table-column>
      <el-table-column prop="pay_order_no" label="支付单号" width="120">
      </el-table-column>
      <el-table-column prop="created_at" label="时间"> </el-table-column>
      <el-table-column prop="order_no" label="订单号"> </el-table-column>
      <el-table-column prop="amount" label="订单金额">
        <template slot-scope="scope">
          <span>{{ scope.row.amount }}({{ scope.row.currency }})</span>
        </template>
      </el-table-column>
      <el-table-column prop="actually_pay" label="实付"></el-table-column>
      <el-table-column prop="cny_amount" label="人民币"> </el-table-column>
      <el-table-column prop="search_name" label="订单状态"> </el-table-column>
      <el-table-column prop="cp_order_no" label="CP订单号"> </el-table-column>

      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            @click="delivery(scope.row.order_no)"
            title=""
            v-if="scope.row.search_name == '已付款'"
            >发货</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200, 500, 1000]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 补单对话框 -->
    <el-dialog
      title="补单"
      :visible.sync="supplementOrderDialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="supplementOrderForm"
        :rules="rules"
        label-width="100px"
        ref="supplementOrderForm"
      >
        <el-form-item label="订单号" prop="order_no">
          <el-input
            v-model="supplementOrderForm.order_no"
            @change="getPayOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="pay_type">
          <el-select
            v-model="supplementOrderForm.pay_type"
            filterable
            clearable
            placeholder="请选择"
            @change="getPayOrderNo"
          >
            <el-option
              v-for="(value, key) in orderPayList"
              :key="key"
              :label="value"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="我方支付单" prop="pay_order_no">
          <el-select
            v-model="supplementOrderForm.pay_order_no"
            filterable
            clearable
            placeholder="请选择"
            :disabled="!payOrderList.length"
          >
            <el-option
              v-for="{created_at, pay_order_no, total_fee} in payOrderList"
              :key="pay_order_no"
              :label="`订单号：${pay_order_no}——金额：${Number(total_fee/100).toFixed(2)}——创建时间：${created_at}`"
              :value="pay_order_no"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="第三方支付单号" prop="trade_no">
          <el-input v-model="supplementOrderForm.trade_no"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="supplementOrderDialogFormVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="supplementOrderSubmit('supplementOrderForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "orders",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        username: "",
        name: "",
        game_id: "",
        order_no: "",
        amount: "",
        status: "",
        cp_order_no: "",
        zone_name: "",
        channel_id: [],
        game_channel_package_id: "",
        created_from: "",
        created_to: "",
        group_channel_ids: "",
        pay_order_no: "",
        pay_type: ""
      },
      tableHeight: 0,
      historyValue: {},
      value: "",
      value1: [],
      tableData: [],
      orderData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 20,
      ordersList: {},
      gamesList: [],
      channelSelectList: [],
      channelSelectAllList: [],
      channelGroupSelectList: [],
      orderPayList: {
        nowpay: "",
        alipay: "",
        wxpay: "",
        applepay: "",
      },
      supplementOrderForm: {
        order_no: "",
        pay_order_no: "",
        trade_no: "",
        pay_type: "",
      },
      supplementOrderDialogFormVisible: false,
      rules: {
        order_no: [{ required: true, message: "请输入订单号", trigger: "blur" }],
        pay_type: [{ required: true, message: '请选择支付方式', trigger: 'change' }],
        pay_order_no: [{ required: true, message: '请选择我方支付单', trigger: 'change' }],
      },
      payTypeList: [],
      payOrderList: [],
    }
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.addDate();
    let date = moment().startOf("month"); //当月第一天
    let y = date.get("year");
    let m = date.get("month") + 1;
    let d = date.get("date");
    let dateStart = y + "-" + m + "-" + d + " " + "00:00:00";

    this.value1[0] = dateStart;
    this.value1[1] = this.systemTime;

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];

    this.getOrderStatus();
    this.getGameSelectList();
    this.getchannelSelectList();
    this.channelGroupSelect();
    this.getOrderList(true);
    this.getPayTypeList()
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getOrderList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getOrderList(false);
    },
    addDate() {
      let date1 = moment().endOf("month"); //当月最后一天
      let yy = date1.get("year");
      let mm = date1.get("month") + 1;
      let dd = date1.get("date");
      this.systemTime = yy + "-" + mm + "-" + dd + " " + "23:59:59";
    },
    // 获取游戏选择列表数据
    getGameSelectList(row) {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        this.gamesList = res.data.data;
      });
    },

    // 获取渠道选择列表数据
    getchannelSelectList(row) {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        this.channelSelectAllList = res.data.data;
        this.channelSelectList = res.data.data;
      });
    },

    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },

    // 根据所属游戏,显示对应的所属渠道
    selectChannel(vid) {
      let obj = {};
      obj = this.gamesList.find((item) => {
        return item.id == vid;
      });
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (obj) {
          if (item.game_id == obj.id) {
            this.channelSelectList.push(item);
          }
        } else {
          this.channelSelectList.push(item);
        }
      });
    },
    // 导出
    exportOrder() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };
      urlSplicing(this.host + "admin/recharge_orders/list", params);
    },
    // 获取订单状态数据
    getOrderStatus(row) {
      fetch({
        url: "/admin/recharge_orders/status",
        method: "GET",
      }).then((res) => {
        this.ordersList = res.data.data;
      });
    },
    // 实现订单列表数据的搜索
    searchOrderList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getOrderList(true);
    },

    // 补单
    // 显示补单对话框
    supplementOrderDialog() {
      this.supplementOrderDialogFormVisible = true;
    },
    // 获取支付单列表
    getPayOrderNo() {
      const { pay_type, order_no } = this.supplementOrderForm
      if (!order_no || !pay_type) return
      this.payOrderList = []
      this.supplementOrderForm.pay_order_no = ''
      fetch({
        url: "/admin/recharge_orders/get_payment_orders",
        method: "POST",
        data: {
          order_no,
          pay_type,
        }
      }).then((res) => {
        if (res.data.status && res.data.data) {
          this.payOrderList = res.data.data
        }
      })
    },
    // 实现补单提交操作
    supplementOrderSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          fetch({
            url: "/admin/recharge_orders/paid",
            method: "POST",
            data: {
              ...this.supplementOrderForm,
            },
          }).then((res) => {
            if (res.data.status === 1) {
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.getOrderList();
              this.supplementOrderDialogFormVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },

    // 发货
    delivery(formName) {
      fetch({
        url: "/admin/recharge_orders/send",
        method: "POST",
        data: {
          order_no: formName,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type: "success",
            message: "发货成功~",
          });
          this.getOrderList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示订单列表数据
    getOrderList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      fetch({
        url: "/admin/recharge_orders/list",
        method: "GET",
        params: {
          //   name: this.searchValue,
          ...searchValue, // 传对应的搜索的值
          channel_id: channel_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data[0].data;
            this.totalRecords = res.data.data[0].total;
            this.orderData = res.data.data.sum;
            let that = this;
            this.tableData.forEach((item, index) => {
              that.tableData[index]["search_name"] =
                that.ordersList[item["status"]];
            });
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    getPayTypeList () {
      fetch({
        url: `/admin/money_orders/pay_type`,
        method: 'GET',
      }).then(res => {
        if (res.data.status && res.data.data) {
          this.payTypeList = res.data.data.filter(item => item)
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
  },
};
</script>
<style lang="less">
ul,
li {
  list-style: none;
}
em {
  font-style: normal;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.order-statistics {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 0;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  li {
    margin-right: 30px;
  }
}
</style>
